/**
 * The phone filter sheet's footer: "Clear all" beside the way back.
 *
 * Clear used to be the last thing inside the panel's scroll, out of sight
 * under the sections; here it is next to the button that closes the sheet,
 * where the decision "keep these or start again" is made. Disabled, not
 * hidden, when nothing is on, so the footer does not change shape as the
 * first filter goes on.
 */

interface FilterSheetFooterProps {
  /** Filters on, excluding the search and the view tabs (outside the sheet). */
  active: number;
  onClear: () => void;
  /** "Show 24 concepts". */
  doneLabel: string;
  onDone: () => void;
}

export function FilterSheetFooter({
  active,
  onClear,
  doneLabel,
  onDone,
}: FilterSheetFooterProps) {
  return (
    <div className='flex flex-shrink-0 gap-2 border-t border-border px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3'>
      <button
        type='button'
        onClick={onClear}
        disabled={active === 0}
        className='h-11 shrink-0 rounded-xl border border-border bg-card px-4 text-sm font-semibold text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:text-muted-foreground'
      >
        Clear all
      </button>
      <button
        type='button'
        onClick={onDone}
        className='h-11 flex-1 rounded-xl bg-primary text-sm font-semibold text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
      >
        {doneLabel}
      </button>
    </div>
  );
}
